export default __webpack_public_path__ + "static/media/permissions-white.2ded90e1.svg";